var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "pt-lg-1 container-fluid" }, [
      _c(
        "div",
        { staticClass: "row align-items-end" },
        [
          _c("cart-banner", {
            staticClass: "col-12 col-md-5 order-1 order-md-2 mb-1",
            attrs: {
              "cart-link": _vm.accessorySelector.cartUrl,
              "number-of-items":
                _vm.accessorySelector.cartBannerDTO.numberOfItemsInCart,
              "cart-enabled": _vm.cartEnabled,
              "search-field-place-holder":
                _vm.accessorySelector.searchFiltersDto.cartBannerSearchLabel,
              "search-results-url":
                _vm.accessorySelector.searchFiltersDto.searchResultsUrl,
              "search-results-query-additional-params":
                _vm.accessorySelector.searchFiltersDto
                  .searchResultsQueryAdditionalParams,
              "algolia-api-key":
                _vm.accessorySelector.searchFiltersDto.algoliaDto.apiKey,
              "algolia-app-id":
                _vm.accessorySelector.searchFiltersDto.algoliaDto.appId,
              "algolia-index-name":
                _vm.accessorySelector.searchFiltersDto.algoliaDto.indexName,
            },
          }),
          _vm._v(" "),
          _c("h1", { staticClass: "col-12 col-md-7 order-2 order-md-1" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.accessorySelector.title) +
                "\n            "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-1", attrs: { id: "mobile-filters" } }, [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            !_vm.showAccessorySpinner
              ? _c("div", { attrs: { id: "total-mobiles" } }, [
                  _c("p", { staticClass: "font-size-16 lead fw-bold mb-0" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.numberOfAccessoryAvailable) +
                        "\n                    "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("ob1-drop-down", {
              staticClass: "ms-auto",
              attrs: {
                id: "mobile-sortBy",
                "is-button": true,
                "drop-down-dto": _vm.dropDownDto,
              },
              on: { "ob1-drop-item-click": _vm.sortAccessories },
            }),
            _vm._v(" "),
            _c("ob1-liens-icone", {
              staticClass: "ms-1",
              attrs: {
                "is-button": true,
                "modal-id": "filters-modal",
                title: _vm.accessorySelector.filterTitle,
                "data-bs-toggle": "modal",
                icon: "icon-filter",
                type: "button",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "slide-popin-modal" },
          [
            _c(
              "slide-popin-modal-filter",
              {
                attrs: {
                  id: "filters-modal",
                  "aria-labelledby": "mobile-filters",
                },
              },
              [
                _c("ob1-liens-icone", {
                  staticClass: "mt-1 noDefaultStyleButton",
                  attrs: {
                    icon: "icon-trash",
                    "is-button": true,
                    title: _vm.categoriesSelected,
                  },
                  on: { click: _vm.deleteSelectionHandler },
                }),
                _vm._v(" "),
                _c("hr", { staticClass: "separator separator--gray4 my-1" }),
                _vm._v(" "),
                _c("selector-shelves", {
                  ref: "selectorShelves",
                  staticClass: "mb-2",
                  attrs: { shelves: _vm.shelvesToShow },
                  on: { "change-check-boxes": _vm.shelvesHandler },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row d-flex justify-content-space-between" },
        [
          _vm.noAccessoryError
            ? _c("ob1-message-alerte", {
                attrs: {
                  title: _vm.noAccessoryError,
                  icon: "icon-info",
                  type: "info",
                },
              })
            : _c("selector-accessories-display", {
                attrs: {
                  accessories: _vm.accessories,
                  "show-accessory-bloc": _vm.showAccessoryBloc,
                  "show-accessory-spinner": _vm.showAccessorySpinner,
                  "show-more-accessories-button": _vm.showMoreAccessoriesButton,
                  "wording-button-more-accessories":
                    _vm.accessorySelector.wordingButtonMoreAccessories,
                  "list-limit": _vm.listLimit,
                  filters: _vm.filters,
                  sort: _vm.sort,
                  "funding-details-dto":
                    _vm.accessorySelector.fundingDetailsDto,
                },
                on: { "fetch-accessories": _vm.showSpinnerOrAccessories },
              }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.accessorySelector.pxfEnabled &&
    _vm.accessorySelector.legalMentions.pxfMention
      ? _c("div", { staticClass: "container-fluid mt-2 mb-2" }, [
          _c("p", {
            staticClass: "fw-bold",
            domProps: {
              innerHTML: _vm._s(_vm.accessorySelector.legalMentions.pxfMention),
            },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "bg-gray2 mt-1 pt-1 pb-1" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _vm.accessorySelector.cb4xEnabled &&
          _vm.accessorySelector.legalMentions.cb4xMention
            ? _c("legal-mentions4x-cb", {
                attrs: {
                  label: _vm.accessorySelector.legalMentions.cb4xMention,
                  "popin4x-cb": _vm.accessorySelector.legalMentions.popin4xCb,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }